import { useContext } from 'react';

import { NotificationsContext } from '../context/NotificationsContext.context';

export function useNotificationContext() {
  const context = useContext(NotificationsContext);
  if (context === undefined) {
    throw new Error(
      'useNotificationContext must be used within a NotificationsProvider'
    );
  }
  return context;
}
